import moment from "moment";
import "moment/locale/es";
import "moment/locale/pt";
import "moment/locale/en-gb";
import { i18n } from "./i18n";

const SUPPORTED = new Set(["es", "en", "pt"]);

export function normalizePanelLanguage(raw) {
  const code =
    (raw && String(raw).trim().toLowerCase().split("-")[0]) || "es";
  return SUPPORTED.has(code) ? code : "es";
}

function momentLocaleFor(lng) {
  if (lng === "pt") return "pt";
  if (lng === "en") return "en-gb";
  return "es";
}

/** Alinea i18next y moment con el idioma del panel (es | en | pt). */
export function applyPanelLanguage(lang) {
  const lng = normalizePanelLanguage(lang);
  const current = (i18n.language || "").split("-")[0];
  if (current !== lng) {
    i18n.changeLanguage(lng);
  }
  moment.locale(momentLocaleFor(lng));
}
